import { gql, useMutation } from '@apollo/client'

export const CART_ITEM_FRAGMENT = gql`
  fragment CartItem on CartItem {
    id
    displayName
    quantity
    itemPrice
    itemsTotal
    displayTotalWeight
    cartItemCustomDimensions {
      id
      value
      customDimensionDimension {
        id
        unit
      }
    }
    item {
      id
      name
      hasClearance
      hasBundle
      hasPreOrder
      hasParentBundle
      readyToShip
      greenLabel
      freeShipping
      bkkFreeShipping
      bkkEecFreeShipping
      freeShippingWithNoMin
      freePickupMh
      listPrice
      price
      displayWeight
      unit
      url
      preOrderProfile {
        id
        min
        max
      }
      priceSummary {
        priceAfterDiscount
        discountSummary {
          discountType
          discountValue
        }
      }
      brand {
        id
        name
        rootBrand {
          id
          name
        }
      }
      productCategories {
        id
        name
      }
      image {
        id
        medium
        small
      }
    }
    subItemsCount
    subCartServiceItemsTotalPrice {
      display
    }
    checked
  }
`

const ADD_ITEMS_TO_CART_MUTATION = gql`
  ${CART_ITEM_FRAGMENT}
  mutation AddItemsToCart($customerNo: String!, $cartItems: [AddItemsToCartInput!]!) {
    addItemsToCart(customerNo: $customerNo, cartItems: $cartItems) {
      addedCartItems {
        ...CartItem
      }
      errors
    }
  }
`

export const useAddItemsToCartMutation = () => {
  const [addItemsToCart, { data, loading, error }] = useMutation(ADD_ITEMS_TO_CART_MUTATION, {
    refetchQueries: ['GetCustomerCart', 'GetCustomerCartItems', 'GetCartDeliveryOptions', 'GetCartSummary'], // For refetching the cart after adding items
  })
  return { addItemsToCart, data, loading, error }
}
